var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/BasePopup/BasePopup.jinja"] = require( "front/components/BasePopup/BasePopup.jinja" );
dependencies["front/components/CommonSidebar/CommonSidebar.jinja"] = require( "front/components/CommonSidebar/CommonSidebar.jinja" );
dependencies["front/components/AwardsCommonWinnersList/AwardsCommonWinnersList.jinja"] = require( "front/components/AwardsCommonWinnersList/AwardsCommonWinnersList.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/AwardsEmmyPopup/AwardsEmmyPopup.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/AwardsEmmyPopup/AwardsEmmyPopup.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n";
env.getTemplate("front/components/BasePopup/BasePopup.jinja", true, "assets/app/front/pages/AwardsEmmyPopup/AwardsEmmyPopup.jinja", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
parentTemplate = t_5
for(var t_4 in parentTemplate.blocks) {
context.addBlock(t_4, parentTemplate.blocks[t_4]);
}
output += "\n\n";
env.getTemplate("front/components/CommonSidebar/CommonSidebar.jinja", false, "assets/app/front/pages/AwardsEmmyPopup/AwardsEmmyPopup.jinja", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
if(Object.prototype.hasOwnProperty.call(t_7, "CommonSidebar")) {
var t_10 = t_7.CommonSidebar;
} else {
cb(new Error("cannot import 'CommonSidebar'")); return;
}
context.setVariable("CommonSidebar", t_10);
output += "\n";
env.getTemplate("front/components/AwardsCommonWinnersList/AwardsCommonWinnersList.jinja", false, "assets/app/front/pages/AwardsEmmyPopup/AwardsEmmyPopup.jinja", false, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
t_11.getExported(function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
if(Object.prototype.hasOwnProperty.call(t_11, "AwardsCommonWinnersList")) {
var t_14 = t_11.AwardsCommonWinnersList;
} else {
cb(new Error("cannot import 'AwardsCommonWinnersList'")); return;
}
context.setVariable("AwardsCommonWinnersList", t_14);
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("popupContent"))(env, context, frame, runtime, function(t_16,t_15) {
if(t_16) { cb(t_16); return; }
output += t_15;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_popupContent(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <div class=\"AwardsEmmyPopup\">\n        <div class=\"AwardsEmmyPopup-headerImage\" data-animation=\"1\" data-animation-type=\"bubble-down\" data-animation-state=\"initial\">\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"data")),"cover")) {
output += "\n                <div class=\"AwardsEmmyPopup-headerImageWrapper\">\n                    <img src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"data")),"cover")),"w1366_url"), env.opts.autoescape);
output += "\"\n                      srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"data")),"cover")),"w1920_url"), env.opts.autoescape);
output += " 1920w,\n                              ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"data")),"cover")),"w1680_url"), env.opts.autoescape);
output += " 1680w,\n                              ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"data")),"cover")),"w1366_url"), env.opts.autoescape);
output += " 1366w,\n                              ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"data")),"cover")),"w920_url"), env.opts.autoescape);
output += " 920w,\n                              ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"data")),"cover")),"w680_url"), env.opts.autoescape);
output += " 680w\"\n                      sizes=\"(max-width: 759px) 1, ";
output += "\n                             (min-width: 760px) and (max-width: 979px) 681, ";
output += "\n                             calc(100% - 240px)\" ";
output += "\n                      alt=\"\">\n                </div>\n            ";
;
}
else {
output += "\n                <div class=\"AwardsEmmyPopup-headerImagePattern\">\n                    ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"data")),"year"), env.opts.autoescape);
output += "\n                </div>\n            ";
;
}
output += "\n        </div>\n\n        <div class=\"AwardsEmmyPopup-yearSelector\">\n            <div class=\"AwardsEmmyPopup-yearSelectorText\">Select Year: <span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"data")),"year"), env.opts.autoescape);
output += "</span></div>\n            <div class=\"AwardsEmmyPopup-yearSelectorIcon\">\n                ";
output += runtime.suppressValue((lineno = 32, colno = 38, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-down","0 0 22 12",runtime.makeKeywordArgs({"caller": (function (){var macro_t_17 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_18 = "";;
frame = frame.pop();
return new runtime.SafeString(t_18);
});
return macro_t_17;})()})])), env.opts.autoescape);
output += "\n            </div>\n            <div class=\"AwardsEmmyPopup-yearSelectorDropdown\">\n                <div class=\"AwardsEmmyPopup-yearSelectorDropdownWrapper\">\n                    ";
frame = frame.push();
var t_21 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"data")),"years");
if(t_21) {t_21 = runtime.fromIterator(t_21);
var t_20 = t_21.length;
for(var t_19=0; t_19 < t_21.length; t_19++) {
var t_22 = t_21[t_19];
frame.set("year", t_22);
frame.set("loop.index", t_19 + 1);
frame.set("loop.index0", t_19);
frame.set("loop.revindex", t_20 - t_19);
frame.set("loop.revindex0", t_20 - t_19 - 1);
frame.set("loop.first", t_19 === 0);
frame.set("loop.last", t_19 === t_20 - 1);
frame.set("loop.length", t_20);
output += "\n                        <a href=\"";
output += runtime.suppressValue((lineno = 37, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:awards_emmy-popup",runtime.makeKeywordArgs({"args": [t_22]})])), env.opts.autoescape);
output += "\" class=\"";
if((t_22 == runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"data")),"year"))) {
output += "AwardsEmmyPopup-yearSelectorDropdownItem--active";
;
}
output += "\">";
output += runtime.suppressValue(t_22, env.opts.autoescape);
output += "</a>\n                    ";
;
}
}
frame = frame.pop();
output += "\n                </div>\n\n            </div>\n        </div>\n\n        <div class=\"AwardsEmmyPopup-title\"><a href=\"";
output += runtime.suppressValue((lineno = 44, colno = 55, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:awards"])), env.opts.autoescape);
output += "\">Awards</a></div>\n        <div class=\"AwardsEmmyPopup-caption\">";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"header")) {
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"header"), env.opts.autoescape);
;
}
else {
output += "Emmy Awards";
;
}
output += "</div>\n\n        <div class=\"AwardsEmmyPopup-content\">\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"data")),"short")) {
output += "\n              <div class=\"AwardsEmmyPopup-short TextFormatting\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"data")),"contentRendered")), env.opts.autoescape);
output += "</div>\n            ";
;
}
else {
output += "\n              <div class=\"AwardsEmmyPopup-year\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"data")),"year"), env.opts.autoescape);
output += "</div>\n              ";
output += runtime.suppressValue((lineno = 52, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "AwardsCommonWinnersList"), "AwardsCommonWinnersList", context, [runtime.makeKeywordArgs({"data": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"data")),"nominees"),"winners": runtime.contextOrFrameLookup(context, frame, "True")})])), env.opts.autoescape);
output += "\n            ";
;
}
output += "\n\n            ";
output += runtime.suppressValue((lineno = 55, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "CommonSidebar"), "CommonSidebar", context, [runtime.makeKeywordArgs({"data": {"content": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"sidebar")}})])), env.opts.autoescape);
output += "\n        </div>\n    </div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_popupContent: b_popupContent,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/AwardsEmmyPopup/AwardsEmmyPopup.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/AwardsEmmyPopup/AwardsEmmyPopup.jinja
// module id = 537
// module chunks = 0